const hasWindow = (prop = null) =>
  prop ? typeof window[prop] !== 'undefined' : typeof window !== 'undefined';

export default hasWindow;
